import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import DataTable from "react-data-table-component";
import Datatablenoresults from "layouts/Datatablenoresults";
import * as styleTable from "styles/datatable";
import CheckboxTable from "fragments/CheckboxTable";
export default function DataTableLayout(_param) {
    var item = _param.item, handleRowSelected = _param.handleRowSelected, columns = _param.columns, isSelectRows = _param.isSelectRows, _param_PerPage = _param.PerPage, PerPage = _param_PerPage === void 0 ? 10 : _param_PerPage, props = _object_without_properties(_param, [
        "item",
        "handleRowSelected",
        "columns",
        "isSelectRows",
        "PerPage"
    ]);
    return /*#__PURE__*/ _jsx(DataTable, {
        columns: columns,
        data: item,
        customStyles: styleTable.customStyles,
        selectableRows: isSelectRows,
        selectableRowsComponent: CheckboxTable,
        pagination: true,
        paginationComponentOptions: styleTable.paginationComponentOptions,
        onSelectedRowsChange: handleRowSelected,
        noDataComponent: /*#__PURE__*/ _jsx(Datatablenoresults, {}),
        persistTableHead: true,
        paginationPerPage: PerPage,
        paginationRowsPerPageOptions: [
            5,
            10,
            25,
            50,
            100
        ]
    });
}
